import React from 'react';
import { bool, object, string } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';

const Checkout = ({ inProgress = false, price }, { general }) => {
    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;

    return (
        <Button type="submit"
            loading={inProgress}
            color={btnColor}>
            <I18n k={'gig_page_perseus.packages.continue'}/>
            <span> ({price})</span>
        </Button>
    );
};

Checkout.propTypes = {
    inProgress: bool,
    price: string
};

Checkout.contextTypes = {
    general: object
};

export default Checkout;
